import "./SidebarTagsDrawer.css";
import Div from "@jumbo/shared/Div/Div";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const SidebarTagsDrawer = ({upperSectionProps, upperSubSectionProps, lowerSectionProps, buttonProps}) => {
    // Checking if both sections are defined
    // If true then there will be two sections with scrolling tags in it
    const isSectionDivided = upperSectionProps !== undefined && lowerSectionProps !== undefined;

    return (
        <div className="sidebar-tags-drawer-wrapper">
            <div className="sidebar-tags-drawer">
                <div className="tags-wrapper">
                    {
                        // UPPER SECTION STARTS
                        // CONTAINS THE FIRST LIST OF THE TAGS
                        upperSectionProps !== undefined && (
                            <Div
                                sx={{
                                    height: isSectionDivided ? "50% !important" : "100%"
                                }}
                                className="tags-wrapper-1 tags-wrapper-item"
                            >
                                <div className="heading-area">
                                    <Typography
                                        component="h4"
                                        sx={{
                                            fontSize: "18px",
                                            fontWeight: "500",
                                            textAlign: "center",
                                            padding: "10px"
                                        }}
                                    >
                                        {upperSectionProps.title}
                                    </Typography>
                                </div>
                                <div className="tags-area customize-scrollbar">
                                    {upperSubSectionProps && (
                                        <div style={{ marginBottom: "1rem" }}>
                                            <Typography
                                                component="h6"
                                                sx={{
                                                    fontWeight: "400",
                                                    textAlign: "end",
                                                    textDecoration: "underline",
                                                    color: "#000052",
                                                    cursor: "pointer"
                                                }}
                                                onClick={() => upperSubSectionProps.setIsAssignAttorneyModalOpen(true)}
                                            >
                                                    {upperSubSectionProps.title}
                                            </Typography>
                                        </div>
                                    )}
                                    {
                                        // selectedRows CONTAINS THE LIST OF THE SELECTED ROWS
                                        upperSectionProps.selectedRows?.map((item) => {
                                            return (
                                                <Chip
                                                    key={item.id}
                                                    className="customize-chip"
                                                    deleteIcon={<CloseIcon/>}
                                                    avatar={null}
                                                    label={item.host_file_number}  // TAG NAME DEFINES WHICH KEY FROM THE ROW OBJECT WILL BE DISPLAYED
                                                    onDelete={() =>
                                                        // setSelectedRows IS A SET FUNCTION FOR HANDLING THE REMOVING OF THE TAGS
                                                        upperSectionProps.setSelectedRows(
                                                            upperSectionProps.selectedRows.filter(
                                                                (allTags) => allTags.id !== item.id
                                                            )
                                                        )
                                                    }
                                                />
                                            );
                                        })
                                    }
                                </div>
                            </Div>
                        )
                    }
                    {lowerSectionProps !== undefined && (
                        <Div
                            sx={{
                                height: isSectionDivided ? "50% !important" : 0
                            }}
                            className="tags-wrapper-2 tags-wrapper-item"
                        >
                            <div className="heading-area">
                                <Typography
                                    component={"h4"}
                                    sx={{
                                        fontSize: "18px",
                                        fontWeight: "500",
                                        textAlign: "center",
                                        padding: "10px"
                                    }}
                                >
                                    {lowerSectionProps.title}
                                </Typography>
                            </div>
                            <div className="tags-area customize-scrollbar">
                                {lowerSectionProps?.selectedRows?.map((item) => {
                                    return (
                                        <Chip
                                            key={item.id}
                                            className="customize-chip orange-chip"
                                            deleteIcon={<CloseIcon/>}
                                            avatar={null}
                                            label={item.form_code}
                                            onDelete={() =>
                                                lowerSectionProps?.setSelectedRows(
                                                    lowerSectionProps?.selectedRows.filter(
                                                        (allTags) => allTags.id !== item.id
                                                    )
                                                )
                                            }
                                        />
                                    );
                                })}
                            </div>
                        </Div>
                    )}
                </div>
                <div className="action-wrapper">
                    <Button
                        variant="contained"
                        sx={{width: "100%"}}
                        endIcon={<ArrowForwardIcon/>}
                        className="btn-theme"
                        disabled={buttonProps?.disabled || false}
                        onClick={() => {
                            buttonProps.onClick();
                        }}
                    >
                        {buttonProps.title}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SidebarTagsDrawer;